import { render, staticRenderFns } from "./first.vue?vue&type=template&id=36694525&scoped=true&"
import script from "./first.vue?vue&type=script&lang=ts&"
export * from "./first.vue?vue&type=script&lang=ts&"
import style0 from "./first.vue?vue&type=style&index=0&id=36694525&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36694525",
  null
  
)

export default component.exports